import { useState } from "react";

export default function CatalogSection() {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = () => {
    setDownloading(true);
    setTimeout(() => setDownloading(false), 2500);
  };

  return (
    <section id="katalog" className="py-16 px-6 bg-white">
      <div className="max-w-[1200px] mx-auto">
        <div
          className="relative overflow-hidden rounded-2xl px-8 md:px-14 py-10 md:py-12 flex flex-col md:flex-row items-center justify-between gap-8"
          style={{
            background: "linear-gradient(135deg, #1e1e1e 0%, #2B2B2B 60%, #1a1a1a 100%)",
            border: "1px solid rgba(255,255,255,0.07)",
          }}
        >
          {/* Background dot grid */}
          <div
            className="absolute inset-0 opacity-[0.035] pointer-events-none"
            style={{
              backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
              backgroundSize: "32px 32px",
            }}
          />

          {/* Ambient glow top-right */}
          <div
            className="absolute -top-20 -right-20 w-72 h-72 rounded-full pointer-events-none"
            style={{
              background: "radial-gradient(circle, rgba(166,106,63,0.18) 0%, transparent 70%)",
              filter: "blur(40px)",
            }}
          />

          {/* Dashed arrow decoration */}
          <div className="hidden lg:block absolute right-[260px] top-1/2 -translate-y-1/2 pointer-events-none select-none">
            <svg width="80" height="40" viewBox="0 0 80 40" fill="none">
              <path
                d="M4 20 Q30 4 60 20"
                stroke="rgba(166,106,63,0.35)"
                strokeWidth="1.5"
                strokeDasharray="5 4"
                fill="none"
              />
              <path
                d="M54 14 L62 21 L52 24"
                stroke="rgba(166,106,63,0.35)"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* Left: Icon + Text */}
          <div className="relative z-10 flex items-center gap-6 md:gap-8">
            {/* Icon box */}
            <div
              className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl"
              style={{
                background: "rgba(166,106,63,0.12)",
                border: "1px solid rgba(166,106,63,0.25)",
                backdropFilter: "blur(12px)",
              }}
            >
              <i className="ri-book-open-line text-3xl md:text-4xl text-[#A66A3F]" />
            </div>

            {/* Text */}
            <div>
              <p className="text-[#A66A3F] text-[10px] font-semibold tracking-[0.22em] uppercase mb-1.5">
                AKSESS Energy Systems
              </p>
              <h2 className="text-white text-2xl md:text-3xl font-bold leading-tight">
                Ürün Kataloğumuzu İnceleyin
              </h2>
              <p className="text-white/40 text-sm mt-2 max-w-sm leading-relaxed">
                Tüm ürün serileri, teknik özellikler ve sertifikalar tek belgede.
              </p>
            </div>
          </div>

          {/* Right: Download Button */}
          <div className="relative z-10 flex-shrink-0">
            <button
              onClick={handleDownload}
              className="group relative flex items-center gap-3 px-8 py-4 rounded-xl font-semibold text-sm tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap overflow-hidden"
              style={{
                background: downloading
                  ? "rgba(166,106,63,0.3)"
                  : "#A66A3F",
                color: "#fff",
                border: "1px solid rgba(166,106,63,0.5)",
                transform: downloading ? "scale(0.97)" : "scale(1)",
              }}
            >
              {/* Shine sweep on hover */}
              <span
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.12) 50%, transparent 60%)",
                }}
              />

              {downloading ? (
                <>
                  <i className="ri-loader-4-line animate-spin text-base" />
                  İndiriliyor...
                </>
              ) : (
                <>
                  <i className="ri-download-2-line text-base" />
                  Kataloğu İndir
                </>
              )}
            </button>

            {/* Meta info below button */}
            <div className="flex items-center justify-center gap-3 mt-2.5">
              <span className="flex items-center gap-1 text-white/25 text-[11px]">
                <i className="ri-file-pdf-line text-xs" />
                PDF Formatı
              </span>
              <span className="text-white/15 text-[11px]">·</span>
              <span className="flex items-center gap-1 text-white/25 text-[11px]">
                <i className="ri-hard-drive-2-line text-xs" />
                ~15 MB
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
